import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useIsZendeskHelpCenterSsoEnabled(): boolean {
  return useCbhFlag(CbhFeatureFlag.ZENDESK_HELP_CENTER_SSO_ENABLED, {
    defaultValue: false,
  });
}
